import React from 'react'
import Badge from './Badge'

/**
 * A faux-but-realistic digest preview for the marketing homepage. Mirrors the
 * look of the real Tuesday email / dashboard cards (score chip, title, meta,
 * badge, one-line why-matched) so visitors see exactly what they'd receive.
 * Leads with "Foundations to approach" — the product's primary matching
 * surface — then a couple of federal grants. Static sample data, illustrative.
 */
const SAMPLE_ITEMS = [
  {
    score: 96,
    title: 'The Cardinal Family Foundation',
    meta: 'Raleigh, NC · Typical grant $10K – $40K',
    badge: <Badge variant="open">🏛️ Foundation</Badge>,
    why: 'Funds youth-services nonprofits and gave 62% of its recent grants in NC.',
  },
  {
    score: 91,
    title: 'Piedmont Community Trust',
    meta: 'Greensboro, NC · Typical grant $5K – $25K',
    badge: <Badge variant="open">🏛️ Foundation</Badge>,
    why: 'Its recent giving echoes your after-school and literacy programs.',
  },
  {
    score: 88,
    title: 'Community Cultural Investment Program',
    meta: 'NEA · Up to $100K · Rolling',
    badge: <Badge variant="open">🟢 Grant</Badge>,
    why: 'Matches your Community Development focus and 501(c)(3) eligibility.',
  },
  {
    score: 84,
    title: 'Youth Creative Workforce Initiative',
    meta: 'Dept. of Labor · $75K – $250K · Due Sep 02',
    badge: <Badge variant="soon">🟡 24d left</Badge>,
    why: 'Overlaps your Employment & Workforce and youth-services profile.',
  },
]

export default function SampleDigest() {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
      {/* Email-style header bar */}
      <div className="bg-brand-900 px-5 py-4 text-white">
        <p className="text-xs text-gray-300">Your Tuesday digest</p>
        <p className="font-semibold">5 foundations to approach · 3 new grants</p>
      </div>

      <div className="p-4 space-y-2 bg-gray-50">
        {SAMPLE_ITEMS.map(item => (
          <div key={item.title} className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 text-center">
                <div className="text-lg font-bold text-brand-500 leading-none">{item.score}</div>
                <div className="text-[10px] text-gray-500 mt-0.5">score</div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <p className="font-medium text-gray-900 text-sm leading-snug">{item.title}</p>
                  <div className="flex-shrink-0">{item.badge}</div>
                </div>
                <p className="text-xs text-gray-500 mt-0.5">{item.meta}</p>
                <p className="text-xs text-gray-600 italic mt-2 border-l-2 border-brand-100 pl-2">
                  {item.why}
                </p>
              </div>
            </div>
          </div>
        ))}
        <p className="text-center text-xs text-gray-500 pt-1">+ more in the full digest</p>
      </div>
    </div>
  )
}
